import { render, staticRenderFns } from "./OnboardingSlider.vue?vue&type=template&id=2c62b9b0&"
import script from "./OnboardingSlider.vue?vue&type=script&lang=ts&"
export * from "./OnboardingSlider.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports